import { pageHabitat as Component } from './page';
export default Component;
